<cdk-virtual-scroll-viewport
  collectionContainer
  #wizNavTree="wizCollContainer"
  #wizCdkList
  wizDragDrop
  [wizDragEnabled]="dragEnabled"
  [wizDropEnabled]="dropEnabled"
  [wizDragMove]="dragMove"
  [wizEnableSelfReorder]="enableSelfReorder"
  [wizDropControlFunction]="checkDragOver"
  [wizShowDropIndicator]="shopDropIndicator"
  class="wiz-cdk-virtual"
  [itemSize]="itemHeight"
  tabindex="0"
  (itemMouseDownEvent)="onInitDrag($event)"
  (keyNavigationEvent)="refreshAfterScroll($event)"
  (selected)="onRowSelected($event)"
  (doubleClicked)="onDoubleClick($event)"
  (space)="toggleNodeFromSpace($event)"
  (openNode)="openCloseFromKey($event,true)"
  (closeNode)="openCloseFromKey($event,false)"
>
  <!-- collection de TIW -->
  <div *cdkVirtualFor="let item of _dataSource; let idx = index" class="wiz-list-row">
    <!-- un élément de noeud
    TODO scroll horizontal si nécessaire [style.padding-right]="item.level * -10 + 'px'" -->
    <wiz-hgroup
      tabIndex="-1"
      collectionItem
      [container]="wizNavTree"  
      [style.height]="itemHeightStr"
      [style.padding-left]="item.level * 10 + 'px'"
      class="wiz-tree-row-item"
      [class.is-selected]="isSelected(item)"
      [itemIndex]="idx"
      [id]="idx"
      [item]="item"
    >
      <!-- le symbole pour expand, class wiz-tree-expand pour afficher le mouse.pointer-->
      <wiz-hgroup class="wiz-tree-expand"  height="100%"  verticalAlign="center"  gap="5" >
        <wiz-icon *ngIf="item.hasChildren" (click)="nodeIconClick($event,item)">
          {{isNodeExpanded(item) ? 'arrow-down' : 'arrow-right'}}
        </wiz-icon>
        <!--  Present pour l'alignement pour afficher correctement le dernier niveau du node  TODO supprimer  -->
        <wiz-spacer *ngIf="!item.hasChildren" height="30px"  width="10px"></wiz-spacer>
      </wiz-hgroup>

      <!-- check pour mode multiselect-->
      <wiz-checkbox
        height="100%"
        class="wiz-tree-node-checkbox"
        *ngIf="multipleSelection"
        [wizCheckState]="getCheckboxState(item)"
        [wizTriStateMode]="true"
        (click)="onCheckSelected($event,item)"
        [wizShowLabel]="false">
      </wiz-checkbox>

      <!-- le contenu de l'item. soit le renderer par défaut, soit un custom -->
      <wiz-hgroup height="100%" verticalAlign="center">
        <ng-container
          *ngTemplateOutlet="getTemplate(); context: { itemRenderer: wizItemRenderer, node: item, index: idx }"
        ></ng-container>
      </wiz-hgroup>
      <!-- éventuelle classe de rendu pour zone "action" à droite du label -->
      <ng-container
        *ngIf="actionsRenderer"
        [ngTemplateOutlet]="dynamicRenderer"
        [ngTemplateOutletContext]="{ itemRenderer: actionsRenderer, node: item, index: idx }"
      ></ng-container>
      <!-- TODO scroll horizontal si nécessaire
      <wiz-spacer  height="30px" width="item.level * 10 + 'px'"></wiz-spacer>-->
    </wiz-hgroup>
  </div>
</cdk-virtual-scroll-viewport>

<!--templates pour l'item : soit défaut (label) soit custom (class)-->
<ng-template #defaultRenderer let-node="node" let-index="index">
  <wiz-label
    height="100%"
    [wizLabel]="getLabel(node)"
    style="color: inherit"
  ></wiz-label
  ><!--  [ngClass]="{'wiz-node-selected': isSelected(node.source)}"-->
</ng-template>
<ng-template #dynamicRenderer let-node="node" let-itemrndr="itemRenderer" let-index="index">
  <div
    [wizTemplateItemRenderer]="itemrndr"
    [context]="node"
    [data]="node.source"
    [owner]="this"
  ></div>
</ng-template>
